<template>
  <div class="page-container">
    <div class="page-header-container">
      <div class="header-left">
        <span class="header-left-back" @click="handleToBack">
          <i class="el-icon-arrow-left"></i> <span> 返回</span></span
        >
        <el-divider direction="vertical"></el-divider>
        <span class="header-left-text">建设技能点</span>
      </div>
      <div class="header-center">百科撰写</div>
      <div class="header-right">
        <el-link
          class="mr-12"
          :underline="false"
          href="https://jiker.feishu.cn/docs/doccnfwavjkQSSxrHTb4432imOh"
          target="_blank"
          ><i class="el-icon-question"></i
        ></el-link>
        <HeaderUser></HeaderUser>
      </div>
    </div>
    <div class="page-content-container">
      <div class="page-content-top flex">
        <div class="content-top-title">{{ stackInfo.name }}</div>
        <!-- <div class="content-top-icon"><i class="el-icon-full-screen"></i></div> -->
      </div>
      <div class="page-content-body">
        <el-card class="content-body flex" shadow="never">
          <div class="content-body-left">
            <div class="body-left-title">知识树</div>
            <div class="body-left-content">
              <el-tree
                :data="treeInfo"
                node-key="id"
                highlight-current
                class="tree-container"
                :expand-on-click-node="false"
                @node-click="handleNodeClick"
                default-expand-all
              >
                <span class="tree-info" slot-scope="{ data }">
                  <span class="tree-info-title">{{ data.text }}</span>
                  <span v-if="data.id">
                    <span v-if="!data.build_content" class="tree-info-text none"
                      >未编辑</span
                    >
                    <span v-else-if="data.build_content">
                      <span
                        class="tree-info-text default"
                        v-if="data.build_content.status == 1"
                        >已编辑</span
                      >
                      <span
                        class="tree-info-text orange"
                        v-else-if="data.build_content.status == 2"
                        >待审核</span
                      >
                      <span
                        class="tree-info-text success"
                        v-else-if="data.build_content.status == 3"
                        >已通过</span
                      >
                      <span
                        class="tree-info-text error"
                        v-else-if="data.build_content.status == 4"
                        >已拒绝</span
                      >
                    </span>
                  </span>
                </span>
              </el-tree>
            </div>
          </div>
          <div class="content-body-right">
            <div class="body-right-nav flex">
              <div class="">
                {{ mode == "info" ? "知识树信息" : targetInfo.text }}
                <!-- <span style="margin-left: 6px" v-if="mode == 'content'">
                  <el-tag size="mini" v-if="targetInfo.status == 2"
                    >建设中</el-tag
                  >
                  <el-tag
                    size="mini"
                    v-else-if="targetInfo.status == 3"
                    type="success"
                    >已上架</el-tag
                  >
                  <el-tag size="mini" v-else type="info">已下架</el-tag>
                </span> -->
                <span
                  class="right-nav-time"
                  v-if="
                    mode == 'content' &&
                      targetInfo.status > 0 &&
                      disabled &&
                      targetInfo.build_content.estimate_reading_time_beautify
                  "
                >
                  预计时长：
                  <el-tooltip
                    effect="dark"
                    content="预计时长=总字数/平均阅读速度(500字/min)*60+图片数*5"
                    placement="top"
                  >
                    <i class="el-icon-warning" style="cursor: pointer;"></i>
                  </el-tooltip>
                  {{
                    targetInfo.build_content
                      ? targetInfo.build_content.estimate_reading_time_beautify
                      : ""
                  }}</span
                >
              </div>
              <div class="right-step-box" v-if="mode == 'content'">
                <img
                  class="right-step"
                  v-if="!targetInfo.build_content"
                  src="../../assets/images/step-1.png"
                />
                <div class="right-step-build" v-else>
                  <img
                    class="right-step"
                    v-if="targetInfo.build_content.status == 1"
                    src="../../assets/images/step-2.png"
                  />
                  <img
                    v-else-if="targetInfo.build_content.status == 2"
                    class="right-step"
                    src="../../assets/images/step-3.png"
                  />
                  <img
                    v-else-if="targetInfo.build_content.status == 3"
                    class="right-step"
                    src="../../assets/images/step-4.png"
                  />
                  <img
                    v-else-if="targetInfo.build_content.status == 4"
                    class="right-step"
                    src="../../assets/images/step-5.png"
                  />
                  <div
                    @click="getRejectData"
                    v-if="targetInfo.build_content.status == 4"
                    class="right-step-seat"
                  ></div>
                </div>
              </div>
              <el-button
                size="small"
                @click="handleSubmit"
                type="primary"
                v-if="
                  mode == 'content' && [0, 1].includes(targetInfo.submitStatus)
                "
                class="submit-btn"
                icon="el-icon-finished"
              >
                提交审核</el-button
              >
              <div v-else></div>
            </div>
            <div v-if="mode == 'content'" class="body-right-content">
              <div class="right-content-title">正文</div>
              <Markdown
                :key="targetInfo.id"
                :autofocus="false"
                class="right-content-markdown"
                :value.sync="targetInfo.newContent"
                space="_for_skill_sub_project"
                folder="admin"
                :defaultOpen="disabled ? 'preview' : 'edit'"
                :disabled="disabled"
              ></Markdown>
              <el-button
                class="right-content-btn"
                @click="handleSave"
                v-if="!Boolean(targetInfo.build_content) || disabled == false"
                type="primary"
                >保存</el-button
              >
              <el-button
                class="right-content-btn"
                @click="disabled = false"
                v-else-if="
                  ![2, 3].includes(targetInfo.submitStatus) && disabled == true
                "
                type="primary"
                >编辑</el-button
              >
            </div>
            <div class="body-right-content" v-else>
              <el-form ref="form" :model="stackInfo" label-width="100px">
                <el-form-item label="技能点：">
                  <el-input
                    size="small"
                    class="w-300"
                    disabled
                    v-model="stackInfo.name"
                  ></el-input>
                </el-form-item>
                <el-form-item label="技能点标识：">
                  <el-input
                    disabled
                    size="small"
                    class="w-300"
                    v-model="stackInfo.slug"
                  ></el-input>
                </el-form-item>
                <el-form-item label="描述：">
                  <el-input
                    disabled
                    class="w-400"
                    v-model="stackInfo.description"
                    type="textarea"
                    :autosize="{ minRows: 4, maxRows: 6 }"
                    size="small"
                    placeholder="请输入描述"
                  ></el-input>
                </el-form-item>
                <el-form-item label="Logo：">
                  <img class="form-img" :src="stackInfo.image_url" alt="" />
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-card>
      </div>
    </div>
    <div
      class="page-chat-btn"
      v-if="!chatVisible && mode == 'content'"
      @click="chatVisible = true"
    >
      <i class="el-icon-d-arrow-left"></i> Kimi
    </div>
    <el-drawer
      class="chat-dialog"
      :visible.sync="chatVisible"
      :modal="false"
      size="840px"
    >
      <div slot="title" class="chat-dialog-header flex">
        <img style="margin-right:10px" src="@/assets/images/kimi.png" />
        <div>Kimi</div>
      </div>
      <div class="chat-dialog-body">
        <div
          :class="[
            'dialog-body-content',
            inputHistory.length > 0 ? '' : 'default'
          ]"
          ref="myElement"
        >
          <div v-for="(item, index) in inputHistory" :key="index">
            <div v-if="index % 2 == 0">
              <div class="content-input">
                <img class="user-input-img" :src="userAvatar" />
                <div class="user-input-content">
                  {{ item.data }}
                </div>
              </div>
              <div v-if="item.upload.length" style="margin-top: 10px;">
                <dvi v-for="file in item.upload" :key="file.id">
                  <div
                    class="upload-item message"
                    v-if="['png', 'jpeg', 'jpg'].includes(file.extension)"
                  >
                    <el-image
                      class="foot-float-img"
                      :src="file.url"
                      :z-index="9999"
                      :preview-src-list="[file.url]"
                    >
                    </el-image>
                  </div>
                  <div v-else class="upload-item message file">
                    <div class="flex">
                      <i class="el-icon-document info-icon"></i>
                      <div>
                        <div class="upload-item-name">
                          {{ file.name }}
                        </div>
                        <div class="upload-item-name">
                          {{ file.extension }}
                        </div>
                      </div>
                    </div>
                  </div>
                </dvi>
              </div>
            </div>
            <div v-else class="content-input chat">
              <img class="user-input-img" src="@/assets/images/kimi.png" />
              <markdown-it-show
                style="padding-top:6px"
                v-if="!chatLoading || inputHistory.length - 1 > index"
                :md="item.data"
                :key="index"
              ></markdown-it-show>
              <span class="animate" v-else-if="inputHistory.length - 1 == index"
                >|</span
              >
              <i
                class="el-icon-copy-document content-icon-copy"
                @click="handleChatCopy(item.data)"
              ></i>
            </div>
          </div>
        </div>
        <div class="dialog-foot">
          <div class="dialog-foot-box">
            <div
              class="foot-default"
              @click="handleActive"
              v-if="!userInputActive"
            >
              让 Kimi 来帮助您构建内容，点击此处 开始提问 ...
            </div>
            <el-input
              v-else
              size="big"
              class="chat-input"
              v-model="userInput"
              @keydown.enter.native="handleChat"
              ref="input-with-select"
            >
              <el-upload
                action=""
                :disabled="uploadBtnLoading"
                :show-file-list="false"
                :before-upload="handleBeforeUpload"
                slot="suffix"
              >
                <i class="el-icon-upload2 el-input__icon"> </i>
              </el-upload>
              <i
                class="el-icon-position el-input__icon"
                slot="suffix"
                @click="handleChat"
              >
              </i>
            </el-input>
            <div class="foot-float" v-if="uploadList.length">
              <div v-for="(item, index) in uploadList" :key="item.id">
                <div
                  class="upload-item"
                  v-if="['png', 'jpeg', ''].includes(item.extension)"
                >
                  <el-image
                    class="foot-float-img"
                    :src="item.url"
                    :z-index="9999"
                    :preview-src-list="[item.url]"
                  >
                  </el-image>
                  <i
                    class="el-icon-error upload-item-delete"
                    @click="handleDeleteUpload(index)"
                  ></i>
                </div>
                <div v-else class="upload-item file">
                  <div class="flex">
                    <i class="el-icon-document info-icon"></i>
                    <div>
                      <div class="upload-item-name" style="margin-bottom: 4px;">
                        {{ item.extension }}
                      </div>
                      <div class="upload-item-name">
                        {{ item.name }}
                      </div>
                    </div>
                  </div>
                  <i
                    class="el-icon-error upload-item-delete"
                    @click="handleDeleteUpload(index)"
                  ></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="chat-dialog-back flex" @click="chatVisible = false">
          <i class="el-icon-d-arrow-right"></i>
          <div class="dialog-back-shadow"></div>
        </div> -->
      </div>
      <div class="chat-wait" v-if="chatLoading">
        正在努力思考 ，请耐心等待
        <div class="loading">
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </el-drawer>
    <el-drawer
      :visible.sync="rejectDrawer"
      :size="560"
      :with-header="false"
      direction="rtl"
      :append-to-body="true"
      :modal-append-to-body="false"
    >
      <div class="rejectDrawer-box" v-loading="drawerLoading">
        <div class="rejectDrawer-header flex">
          <div>驳回信息</div>
          <i class="el-icon-close" @click="rejectDrawer = false"> </i>
        </div>
        <div class="rejectDrawer-body">
          <div class="reject-item">
            <div
              class="reject-item-info "
              v-for="(item, index) in rejectInfo.verify_logs"
              :key="index"
            >
              <div class="flex" style="justify-content: space-between;">
                <div>时间：{{ item.created_at }}</div>
                <div>
                  操作人：{{ item.operator.realname || item.operator.name }}
                </div>
              </div>
              <div class="reject-item-content">
                <markdown-it-show
                  :md="item.reason || item.action_label"
                ></markdown-it-show>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { mapState } from "vuex";
import skillService from "@/global/service/skill";
import Markdown from "@/components/Markdown";
import MarkdownItShow from "@jiker/markdown-it/MarkdownIt.vue";
import HeaderUser from "../../components/HeaderUser.vue";
import { fetchEventSource } from "@microsoft/fetch-event-source";
import Cookie from "js-cookie";
import qiniuService from "@/global/service/qiniu";
import API from "@/global/request/api";

// "coc98dpldu5htg3uhf5g"

// "coc98o1hmfr6003l851g"
export default {
  components: {
    Markdown,
    MarkdownItShow,
    HeaderUser
  },
  computed: {
    ...mapState(["userAvatar", "userName", "authPermissions"])
  },
  updated() {
    // 聊天定位到底部
    if (this.$refs["myElement"]) {
      let ele = this.$refs["myElement"];
      ele.scrollTop = ele.scrollHeight;
    }
  },
  data() {
    return {
      treeInfo: [],
      defaultProps: {
        children: "children",
        label: "text"
      },
      rejectDrawer: false,
      inputHistory: [],
      userInput: "",
      targetInfo: {
        build_content: {}
      },
      uploadBtnLoading: false,
      userInputActive: false,
      mode: "info",
      chatVisible: false,
      chatLoading: false,
      interval: 100,
      id: this.$route.params.id,
      knowledge: {},
      form: {},
      disabled: false,
      active: 2,
      stackInfo: {},
      rejectInfo: {
        verify_logs: []
      },
      chatInputIndex: null,
      chatId: null,
      drawerLoading: false,
      TOKEN: Cookie.get("token"),
      chatFileIds: [],
      uploadList: []
    };
  },
  created() {
    this.getData();
    this.getChatGptDialog();
  },
  watch: {
    inputHistory(val) {
      this.chatInputIndex = val.length;
    },
    targetInfo(val) {
      this.userInput = `在${this.stackInfo.name}下，针对${val.text}知识点，写一篇详细的教程`;
    }
  },
  methods: {
    getData() {
      skillService.getSkillKnowledgeInfo(this.id).then(res => {
        this.treeInfo = this.deleteChildren(res.jstreeData);
        this.stackInfo = res.stack;
        // this.targetInfo.text = res.jstreeData[0].text;
      });
    },
    getChatGptDialog() {
      skillService.getGptDialog().then(res => {
        this.chatDialogUuid = res.uuid;
      });
    },
    handleSubmit() {
      if (this.targetInfo.newContent) {
        skillService
          .submitSkillKnowledgeVerify(this.id, this.targetInfo.id)
          .then(() => {
            this.$set(this.targetInfo.build_content, "status", 2);
            this.$message.success("提交审核成功");
          });
      } else {
        this.$message.error("请先保存百科信息后再进行提交审核");
      }
    },
    handleNodeClick(e) {
      this.targetInfo = e;
      if (e.id) {
        this.mode = "content";
        this.targetInfo = e;
        this.targetInfo.newContent =
          (e.build_content ? e.build_content.content : e.content) || "";
        this.disabled = this.targetInfo.build_content ? true : false;
        this.targetInfo.submitStatus = this.targetInfo.build_content
          ? this.targetInfo.build_content.status
          : 0;
      } else {
        this.mode = "info";
      }
    },
    handleDeleteUpload() {
      this.uploadList = [];
      this.chatFileIds = [];
    },
    handleSave() {
      const params = {
        content: this.targetInfo.newContent
      };
      skillService
        .saveSkillKnowledgeContent(this.id, this.targetInfo.id, params)
        .then(res => {
          this.targetInfo.build_content = this.targetInfo.build_content
            ? this.targetInfo.build_content
            : {};
          this.$set(
            this.targetInfo.build_content,
            "content",
            this.targetInfo.newContent
          );
          this.$set(this.targetInfo.build_content, "status", 1);
          this.$set(this.targetInfo, "submitStatus", 1);
          this.$set(
            this.targetInfo.build_content,
            "estimate_reading_time_beautify",
            res.estimate_reading_time_beautify
          );
          this.$message.success("百科保存成功");
          this.disabled = true;
        });
    },
    handleBeforeUpload(file) {
      if (!file || this.uploadBtnLoading || !this.validateSize(file)) {
        return false;
      }
      this.$message.success("上传中，请稍等");
      const space = "_for_gpt_project";
      const folder = "kimi";
      const api = API.chatGptFiles;
      this.uploadBtnLoading = true;
      qiniuService
        .upload({ space, folder, file, api }, () => {})
        .then(res => {
          skillService
            .chatGptKiMiFiles({ file_id: res.id })
            .then(data => {
              this.chatFileIds.push(data.kimi_file_id);
              this.uploadList.push(res);
              this.$message.success("上传成功");
            })
            .catch(() => {});
        })
        .finally(() => {
          this.uploadBtnLoading = false;
        });
      return false;
    },
    validateSize(file) {
      const size = 5 * 1024 * 1024;
      const suffix = file.name.split(".").pop();
      const fileType = [
        "pdf",
        "doc",
        "docx",
        "xlsx",
        "ppt",
        "txt",
        "md",
        "jpeg",
        "png",
        "jpg"
      ];
      if (file.size > size || !fileType.includes(suffix)) {
        this.$message.error(
          `请上传不大于 5MB 且格式为：PDF、Word 文档（DOC、DOCX）、Excel 表格（XLSX）、PPT（PPT、PPTX）、图片、CSV、各类纯文本格式等。`
        );
        return false;
      }
      return true;
    },
    handleChat() {
      if (!this.userInput || this.chatLoading) {
        return;
      }
      this.chatLoading = true;
      const input = JSON.parse(JSON.stringify(this.userInput));
      const params = {
        prompt: input,
        uuid: this.chatDialogUuid,
        kimi_ids: this.chatFileIds
      };
      this.inputHistory.push({ data: input, upload: this.uploadList });

      let message = "";
      this.inputHistory.push({ data: "", upload: "" });
      this.userInput = null;
      const abortController = new AbortController();
      const url = `https://kcell-service.prodegree.${
        process.env.VUE_APP_ENV == "production" ? "com" : "cc"
      }/api/jiker/fuwu/gpt/chat`;
      const that = this;
      this.uploadList = [];
      fetchEventSource(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.TOKEN,
          "Platform-Id": "jiker_fuwu_admin"
        },
        signal: abortController.signal,
        body: JSON.stringify(params),
        onopen() {
          that.chatLoading = false;
          that.chatFileIds = null;
        },
        onmessage(event) {
          that.chatLoading = false;
          const data = JSON.parse(event.data);
          if (data.choices[0].finish_reason == "stop") {
            abortController.abort();
          } else {
            message += data.choices[0].delta?.content;
            that.inputHistory[that.inputHistory.length - 1].data = message;
          }
        },
        onerror(err) {
          that.chatLoading = false;
          abortController.abort();
          throw err;
        },
        onclose() {
          abortController.abort();
        },
        openWhenHidden: true
      });
    },
    getRejectData() {
      this.drawerLoading = true;
      skillService
        .getSkillKnowledgeContent(this.id, this.targetInfo.id)
        .then(res => {
          this.rejectDrawer = true;
          this.rejectInfo = res;
        })
        .finally(() => {
          this.drawerLoading = false;
        });
    },
    handleToBack() {
      this.$router.back();
    },
    deleteChildren(arr) {
      let childs = arr;
      for (let i = childs.length; i--; i > 0) {
        if (childs[i].children) {
          if (childs[i].children.length) {
            this.deleteChildren(childs[i].children);
          } else {
            delete childs[i].children;
          }
        }
      }
      return arr;
    },
    handleActive() {
      this.userInputActive = true;
      this.$nextTick(() => {
        this.$refs[`input-with-select`].focus();
      });
    },
    handleChatCopy(item) {
      let input = "";
      if (item.indexOf("```")) {
        input = document.createElement("textarea");
      } else input = document.createElement("input");
      input.setAttribute("readonly", "readonly");
      input.value = item;
      document.body.appendChild(input);
      input.select();
      if (document.execCommand("copy")) document.execCommand("copy");
      document.body.removeChild(input);
    }
  }
};
</script>

<style lang="less" scoped>
.flex {
  display: flex;
  align-items: center;
}
/deep/.el-dropdown-menu__item:focus,
.el-dropdown-menu__item:not(.is-disabled):hover {
  background-color: #f0f2f5;
  color: #666666;
  // .dropdown-item {
  //   color: #66b1ff;
  // }
}
.dropdown-user {
  width: 176px;
  height: 132px;
  padding: 14px 24px 24px;
  text-align: center;
  border-bottom: 1px solid #e8e8e8;
  margin-bottom: 4px;
  .dropdown-user-img {
    width: 48px;
    height: 48px;
    object-fit: contain;
  }
  .dropdown-user-name {
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 22px;
    margin-top: 8px;
  }
}
/deep/.el-dropdown-menu__item--divided:before {
  margin: 0 4px;
  opacity: 0;
  display: none;
}
/deep/.el-dropdown-menu__item {
  margin: 0 4px;
  padding: 0 12px;
  color: #666666;
}
.page-header-right {
  display: flex;
  align-items: center;
  padding: 0 20px;
  height: 100%;
  transition: all 0.2s ease;
  cursor: pointer;
  // &:hover {
  //   background: #ecf5ff;
  // }
  .user-avatar {
    margin-right: 12px;
    width: 30px;
    height: 30px;
    border-radius: 50%;
  }
  .user-name {
    margin-right: 12px;
    font-size: 14px;
  }
}
.dropdown-item {
  color: #606266;
}
.animate {
  display: inline-block;
  padding: 0 5px;
  font-size: 14px;
  padding-top: 6px;
  animation: fade 1s infinite forwards;
}
@keyframes fade {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

//一级节点选择器
/deep/ .el-tree > .el-tree-node > .el-tree-node__content {
  font-weight: 500;
  color: rgba(0, 0, 0, 0.85) !important;
  font-family: PingFangSC-Medium, PingFang SC;
}
.user-input-content {
  display: flex;
  .input-content-img {
    width: 50px;
    height: 50px;
    flex-shrink: 0;
    margin-left: 10px;
    object-fit: cover;
  }
  /deep/ol,
  ul {
    padding-left: 18px !important;
  }
}

.submit-btn {
  width: 100px;
  height: 32px;
  font-size: 14px;
  padding: 4px;
}
//二级节点选择器
/deep/
  .el-tree
  > .el-tree-node
  > .el-tree-node__children
  > .el-tree-node
  > .el-tree-node__content {
  font-family: PingFangSC-Regular, PingFang SC !important;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.85);
}
/deep/.el-tree-node__content {
  margin-bottom: 6px;
}

/deep/.el-tree-node__content:hover {
  background: rgba(64, 158, 255, 0.1);
}
/deep/.el-tree--highlight-current
  .el-tree-node.is-current
  > .el-tree-node__content {
  background: rgba(64, 158, 255, 0.1);
}
.form-img {
  width: 72px;
  height: 72px;
  object-fit: contain;
}
.rejectDrawer-box {
  height: 100%;
  width: 100%;
  // display: flex;
  // flex-direction: column;
  // justify-content: space-between;
  .rejectDrawer-header {
    justify-content: space-between;
    padding: 16px 24px;
    border-bottom: 1px solid rgba(217, 217, 217, 1);
    div {
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.85);
    }
    i {
      cursor: pointer;
    }
  }
  .rejectDrawer-body {
    padding: 0 24px 20px;

    .reject-item {
      .reject-item-info {
        justify-content: space-between;
        font-size: 14px;
        margin-top: 32px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.45);
        .reject-item-content {
          margin-top: 12px;
          width: 100;
          padding: 16px;
          background: rgba(0, 0, 0, 0.02);
          border-radius: 2px;
        }
      }
    }
  }
}
.steps-container {
  .steps-item {
    .steps-item-round {
      width: 16px;
      height: 16px;
      line-height: 16px;
      font-size: 10px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.45);
      border: 1px solid rgba(0, 0, 0, 0.45);
      text-align: center;
      border-radius: 50%;
      margin-right: 4px;
    }
    .steps-item-text {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.45);
    }
  }
  .steps-line {
    width: 16px;
    height: 1px;
    background: rgba(0, 0, 0, 0.25);
    margin: 0 4px;
  }
}
.upload-item {
  min-width: 100px;
  height: 60px;
  display: inline-block;
  position: relative;
  border: 1px solid rgba(99, 117, 140, 0.1);
  margin-right: 10px;
  &.file {
    padding: 10px;
  }
  &.message {
    // border: none;
    margin-left: 20px;
    border-radius: 4px;
    background-color: #fff;
  }
  .foot-float-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border: 1px solid rgba(99, 117, 140, 0.1);
  }
  .upload-item-delete {
    position: absolute;
    color: red;
    right: -6px;
    top: -6px;
    cursor: pointer;
  }
  // line-height: 60px;
  .info-icon {
    font-size: 24px;
    color: rgba(0, 0, 0, 0.2);
    margin-right: 10px;
  }
  .upload-item-name {
    color: #72767b;
    font-size: 12px;
  }
}
.page-container {
  position: relative;
  min-width: 1440px;
  height: 100vh;
  width: 100%;
  background: #f2f3f5;
  .chat-dialog {
    .chat-wait {
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      top: 42%;
      left: 33%;
      width: 220px;
      // height: 40px;
      line-height: 30px;
      // border: 1px solid #000000;
      box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05),
        0px 6px 16px 0px rgba(0, 0, 0, 0.08),
        0px 3px 6px -4px rgba(0, 0, 0, 0.12);
      border-radius: 2px;
      font-size: 14px;
      background: #fff;
      color: rgba(0, 0, 0, 0.65);

      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      // padding: 4px 10px;
      // text-align: center;
      .loading,
      .loading > div {
        position: relative;
        box-sizing: border-box;
      }

      .loading {
        display: block;
        font-size: 0;
        color: rgba(0, 0, 0, 0.65);
      }

      .loading.la-dark {
        color: rgba(0, 0, 0, 0.65);
      }

      .loading > div {
        display: inline-block;
        float: none;
        background-color: currentColor;
        border: 0 solid currentColor;
      }

      .loading {
        width: 30px;
        height: 18px;
        padding-top: 3px;
      }

      .loading > div {
        width: 3px;
        height: 3px;
        margin: 2px;
        border-radius: 100%;
        opacity: 0;
        animation: ball-fall 1s ease-in-out infinite;
      }

      .loading > div:nth-child(1) {
        animation-delay: -200ms;
      }

      .loading > div:nth-child(2) {
        animation-delay: -100ms;
      }

      .loading > div:nth-child(3) {
        animation-delay: 0ms;
      }

      @keyframes ball-fall {
        0% {
          opacity: 0;
          transform: translateY(-145%);
        }

        10% {
          opacity: 0.5;
        }

        20% {
          opacity: 1;
          transform: translateY(0);
        }

        80% {
          opacity: 1;
          transform: translateY(0);
        }

        90% {
          opacity: 0.5;
        }

        100% {
          opacity: 0;
          transform: translateY(145%);
        }
      }

      // color: #ffffff;
    }
    /deep/.el-dialog {
      display: flex;
      flex-direction: column;
      margin: 0 !important;
      position: absolute;
      top: 18%;
      right: 0;
      height: 600px;
      box-shadow: 0px 2px 16px 0px rgba(0, 0, 0, 0.16);
    }
    /deep/.el-dialog__headerbtn {
      top: 16px !important;
    }
    /deep/.el-dialog__header {
      display: flex;
      align-items: center;
      border-bottom: 1px solid #d9d9d9;
      padding: 16px;
    }
    /deep/.el-dialog__body {
      height: 100%;
      padding: 0;
      z-index: 100;
      position: relative;
    }
    .chat-dialog-body {
      // height: 100%;
      background-color: #fff;
      position: relative;
      .dialog-body-content {
        overflow-y: auto;
        height: calc(100vh - 76px);
        padding-bottom: 130px;
        &.default {
          background: url("../../assets/images/icon-GPT-gray.svg") no-repeat 50%
            42%;
        }
        .content-input {
          width: 100%;
          display: flex;
          align-items: flex-start;
          padding: 12px 24px 12px 16px;
          position: relative;
          background: rgba(0, 0, 0, 0.04);
          &:hover {
            .content-icon-copy {
              display: block;
            }
          }
          &.chat {
            background: #fff;
            margin-top: 4px;
          }
          .user-input-img {
            width: 32px;
            height: 32px;
            border-radius: 2px;
            object-fit: cover;
            margin-right: 12px;
          }
          .user-input-content {
            padding-top: 6px;
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: rgba(0, 0, 0, 0.85);
            line-height: 22px;
          }
          .content-icon-copy {
            position: absolute;
            right: 1%;
            top: 22px;
            display: none;
            color: rgba(0, 0, 0, 0.65);

            cursor: pointer;
            &:hover {
              color: #409eff;
            }
          }
        }
      }

      .dialog-foot {
        width: 100%;
        position: absolute;
        // text-align: center;
        bottom: 90px;

        .dialog-foot-box {
          position: relative;
          width: 100%;
          display: flex;
          justify-content: center;
        }
        .foot-float {
          position: absolute;
          width: 90%;
          padding: 20px;
          background-color: #fff;
          left: 42px;
          top: -106px;
          border: 1px solid rgba(99, 117, 140, 0.1);
          border-bottom: none;
          display: flex;
          align-items: center;
        }
        .chat-input {
          width: 90%;
          margin: 0 auto;
          /deep/.el-input__inner {
            padding-right: 90px !important;
          }
          /deep/.el-input__suffix {
            right: 12px;

            .el-input__suffix-inner {
              display: flex;
            }
          }
          i {
            font-size: 18px;
            cursor: pointer;
            margin-right: 8px;
            &:hover {
              color: rgba(0, 0, 0, 0.45);
            }
          }
        }
        .foot-default {
          padding: 0 12px;
          height: 34px;
          margin: 0 auto;
          line-height: 32px;
          background: #f3f4f7;
          border-radius: 2px;
          border: 1px solid rgba(99, 117, 140, 0.1);
          cursor: pointer;
          font-size: 14px;
          width: 90%;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #7c8ca6;
        }
        // .input-with-select {
        //   /deep/.el-input__inner {
        //     height: 33px;
        //     // border-color: #bac1ca;
        //     border: 1px solid #bac1ca;
        //     line-height: 33px;
        //     &:focus {
        //       border: 2px solid #bac1ca;
        //     }
        //   }
        //   /deep/.el-button {
        //     background: #7989a2;
        //     border-radius: 0px 2px 2px 0px;
        //     font-size: 14px;
        //     font-family: PingFangSC-Medium, PingFang SC;
        //     font-weight: 500;
        //     width: 76px;
        //     color: #ffffff;
        //     &:hover {
        //       filter: brightness(1.1);
        //     }
        //   }
        //   height: 34px;
        // }
      }
      .chat-dialog-back {
        z-index: 2002;
        justify-content: space-between;
        position: absolute;
        bottom: 1px;
        left: -41px;
        cursor: pointer;
        width: 40px;
        height: 38px;
        line-height: 38px;
        &:hover {
          filter: brightness(1.1);
        }
        i {
          color: #fff;
          cursor: pointer;
        }
        padding-left: 18px;
        background: #7787a0;
        box-shadow: 0px 2px 16px 0px rgba(0, 0, 0, 0.16);
        // border-radius-: 20px;
        border-top-left-radius: 20px;
        border-bottom-left-radius: 20px;

        .dialog-back-shadow {
          cursor: pointer;
          width: 2px;
          height: 100%;
          background: #7787a0;
          box-shadow: 0px 2px 16px 0px rgba(0, 0, 0, 0.16);
        }
      }
    }
  }

  .page-chat-btn {
    position: absolute;
    right: 0%;
    bottom: 12%;
    z-index: 1600;
    width: 114px;
    padding-left: 18px;
    height: 38px;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    line-height: 38px;
    background: #42ccab;
    cursor: pointer;
    box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.2);
    border-radius: 20px 0px 0px 20px;
    &:hover {
      filter: brightness(1.1);
    }
  }
  .page-header-container {
    padding: 20px 24px;
    width: 100%;
    height: 72px;
    background: #fff;
    box-shadow: 0px 1px 2px 0px rgba(217, 217, 217, 0.83);
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    .header-center {
      position: absolute;
      left: 50%;
      line-height: 70px;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #409eff;
      border-bottom: 2px solid #409eff;
    }
    .header-left {
      .header-left-back {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.45);
        cursor: pointer;
        &:hover {
          color: rgba(0, 0, 0, 0.65);
        }
      }
      .header-left-text {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.65);
      }
    }
    .header-right {
      display: flex;
      align-items: center;
      .header-right-img {
        width: 32px;
        height: 32px;
        border-radius: 50%;
        cursor: pointer;
        object-fit: cover;
      }
      .header-right-icon {
        margin-right: 24px;
      }
    }
  }
  .page-content-container {
    width: 100%;
    padding: 24px;
    height: calc(100vh - 72px);
    .page-content-top {
      justify-content: space-between;
      margin: 8px 0 16px;
      .content-top-title {
        font-size: 24px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #000000;
      }
      .content-top-icon {
        width: 32px;
        height: 32px;
        line-height: 32px;
        text-align: center;
        background: #fafafa;
        cursor: pointer;
      }
    }
    .page-content-body {
      /deep/.el-card__body {
        padding: 0% !important;
        height: 100%;
        width: 100%;
        display: flex;
        align-items: center;
      }
      height: calc(100% - 58px);
      .content-body {
        height: 100%;
        width: 100%;
        .content-body-left {
          width: 408px;
          height: 100%;
          padding: 24px;
          border-right: 1px solid #e5e5e5;
          .body-left-title {
            font-size: 20px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #000000;
            margin-bottom: 16px;
          }
          .body-left-content {
            width: 100%;
            height: calc(100% - 44px);
            // background: rgba(0, 0, 0, 0.02);
            .tree-container {
              height: 100%;
              background: rgba(0, 0, 0, 0.02);
              padding: 20px 12px;
              overflow-y: auto;
              /deep/.el-icon-caret-right {
                color: rgba(0, 0, 0, 0.65);
                &.is-leaf {
                  color: transparent;
                }
              }
              .tree-info {
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding-right: 8px;
                width: 100%;
                .tree-info-title {
                  font-size: 14px;
                }
                .tree-info-text {
                  font-size: 12px;
                  font-family: PingFangSC-Regular, PingFang SC;
                  font-weight: 400;
                  &.none {
                    color: #c9c9c9;
                  }
                  &.default {
                    color: #68718e;
                  }
                  &.success {
                    color: #53bd6f;
                  }
                  &.error {
                    color: #f67e7e;
                  }
                  &.orange {
                    color: #fa8c16;
                  }
                }
              }
            }
          }
        }
        .content-body-right {
          flex: 1;
          width: calc(100% - 408px);
          height: 100%;
          .body-right-nav {
            justify-content: space-between;
            padding: 16px 24px;
            width: 100%;
            height: 56px;
            background: rgba(0, 0, 0, 0.02);
            box-shadow: inset 0px -1px 0px 0px #e5e5e5;
            filter: blur(0px);
            position: relative;
            .right-nav-time {
              font-size: 13px;
              margin-left: 20px;
              color: rgba(0, 0, 0, 0.65);
            }
            .right-step-box {
              position: absolute;
              left: 38%;
              top: 32%;
              .right-step {
                // width: 254px;
                height: 20px;
                object-fit: cover;
              }
              .right-step-build {
                position: relative;
              }
              .right-step-seat {
                width: 160px;
                height: 20px;
                opacity: 0;
                right: 0;
                top: 0;
                position: absolute;
                cursor: pointer;
              }
            }
          }
          .body-right-content {
            padding: 20px 24px;
            height: calc(100% - 56px);
            .right-content-title {
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #bfbfbf;
              line-height: 28px;
              margin-bottom: 8px;
            }
            .right-content-markdown {
              height: 84%;
              /deep/.markdown-body {
                height: 100% !important;
              }
            }
            .right-content-btn {
              margin-top: 16px;
              height: 40px;
              width: 160px;
              padding: 4px;
              font-size: 16px;
            }
          }
        }
      }
    }
  }
}
</style>
